import React, { useState, useEffect } from 'react';
import Button from '../common/ui-components/input/Button';
import  ChildPlanList from '../common/ChildPlanList';
import styles from '../../styles/modules/components/SelfServe/child-page.module.scss';
import accordionStyles from '../../styles/modules/ui-components/accordion.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';
import {
    changeProgress,
    updateDeviceDetails,
} from '../../redux/actions/selfserveActions';
import { selectPlan } from '../../tracking/selfserveTracking';
import { HOMECARE_PLANS, HOMECARE_PREMIUM_PRODUCTS, SELECT_DEVICE, ADD_DEVICE, HOMECARE_FEST_MAX_CLAIMS } from '../../constants/index';
import AddDeviceDetails from '../common/AddDeviceDetails';
import UIAccordion from '../common/ui-components/surface/UIAccodion';
import EraseSRListAlert from './EraseSRListModal';
import { addAppRenderParams } from '../../utils/selfserve';

// interface PlanCard {
//     onClick: (e: React.MouseEvent) => void,
//     onClickChild: (e: React.MouseEvent, childItem: any) => void,
//     onClickOnHCPlan: (e: React.MouseEvent) => void,
//     style?: object,
//     className?: string | null,
//     children?: React.ReactNode,
//     disabled?: boolean,
//     plan: any,
//     key: any,
//     is_selected: Boolean,
//     selected_plan_id: number,
//     is_show_child_plan: Boolean,
//     onClickSetShowChildPlan: (e: React.MouseEvent) => void,
//     index: number,
//     show_plan_index: any,
//     ticket_list: any
// }

// interface ChildPlanCard {
//     onClick: (e: React.MouseEvent) => void,
//     style?: object,
//     className?: string | null,
//     children?: React.ReactNode,
//     disabled?: boolean,
//     childPlan: any,
//     key: any,
//     is_selected: Boolean,

// }

// interface ReduxStateProps {
//     selfserveReducer: any,
//     setPageLoading: (data: Boolean) => void,
//     customerExists: boolean,
//     cart: any
// }

// interface MainProps {
//     subIssues: any
// }

// type Props = ReduxStateProps & MainProps;

const ChildPlanPage = (props: any) => {

    const dispatch:any = useDispatch();

    const {
        deviceDetails: deviceDetailsObj,
        editScreen: { isEditing },
        parentPlanDetails,
        planCovers,
        previousStepList,
    } = props.selfserveReducer

    const [disableBtn, setDisableBtn] = useState<boolean>(
        parentPlanDetails.hasOwnProperty('button_disabled')
            ? parentPlanDetails.button_disabled
            : true);
    // Getting Fetched Plans from Redux Store
    // IF Covers available on selected plan is more than 1 will display covers page
    const [, setCoversNo] = useState(planCovers.length);

    const [deviceDetails, setDeviceDetails] = React.useState<object>({});

    const [selectedAccordion, setSelectedAccordion] = React.useState<String>();

    // EarseSR Modal
    const [earseSR, setEarseSR] = useState(false);
    const [scrollTop, setScrollTop] = useState(215);
    const router = useRouter()
    const screenSizes = {
      1180: 160,
      768: 80,
      576: 100
    }

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, 'behavior': 'smooth' });
        let windowWidth = window.innerWidth;
        let currentScrollTop = 215;
        Object.keys(screenSizes).reverse().forEach(size => {
          if (windowWidth < parseInt(size)) {
            currentScrollTop = screenSizes[size];
          }
        });
        setScrollTop(currentScrollTop);
        const {
                parentPlanDetails: { plan_name, hcb_serviced_devices,homecare_device_plan_list },
                deviceDetails,
            } = props.selfserveReducer
        if (
            HOMECARE_PLANS.includes(plan_name) && hcb_serviced_devices.length != 0
            &&
            (!Object.keys(deviceDetails).length || (
                Object.keys(deviceDetails).length && deviceDetails.device_id
            ))) {
            setSelectedAccordion(SELECT_DEVICE)
            if (deviceDetails.deviceKey) {
                setDisableBtn(false)
            }
        } else if (
            HOMECARE_PREMIUM_PRODUCTS.includes(plan_name)
            &&
            homecare_device_plan_list.length != 0
            && (!Object.keys(deviceDetails).length || deviceDetails.deviceKey)) {

            setSelectedAccordion(SELECT_DEVICE)
            if (deviceDetails.deviceKey) {
                setDisableBtn(false)
            }
        } else {
            setSelectedAccordion(ADD_DEVICE)
        }
    }, [])


    //check this functionally
    // Handles the logic For NEXT Button
    const handlebutton = () => {
        selectPlan(); //gtm tracking event
        //here add one more condition related to select device or just select device in hcb

        if (selectedAccordion == ADD_DEVICE && HOMECARE_PLANS.includes(parentPlanDetails.plan_name)) {
            if(isEditing){
                Object.keys(deviceDetails).length && dispatch(updateDeviceDetails(deviceDetails,true))
            }else{
                Object.keys(deviceDetails).length && dispatch(updateDeviceDetails(deviceDetails))
            }
        }
        dispatch(changeProgress(4,true));
    }
    const handleAccordion=(accordionName)=>{
        if(accordionName == ADD_DEVICE && Object.keys(deviceDetails).length){
            setDisableBtn(false)
        }else if(accordionName == SELECT_DEVICE && deviceDetailsObj.deviceKey){
            setDisableBtn(false)
        }else{
            setDisableBtn(true)
        }
        setSelectedAccordion(accordionName)
        window.scrollTo({ top: scrollTop, left: 0, 'behavior': 'smooth' })
    }

    const getMaxClaimValidity = () => {
      let currentSrs = Object.keys(props.selfserveReducer.ticket_list).length;
      if (!currentSrs) {
        currentSrs = 0;
      }

      if (props.selfserveReducer.parentPlanDetails.plan_name === "HomeCare Fest") {
        return ((props.selfserveReducer.parentPlanDetails.total_claims + currentSrs) < HOMECARE_FEST_MAX_CLAIMS)
      } else {
        return true;
      }
    }

    return (
        <div>
            <div className={`${styles.top_link}`}>
              <h5>Select The Devices To Be Serviced</h5>
            </div>



            {/* This are accordion use */}
            {(parentPlanDetails?.hcb_serviced_devices?.length != 0 || parentPlanDetails?.homecare_device_plan_list?.length != 0)
                && !HOMECARE_PREMIUM_PRODUCTS.includes(parentPlanDetails.plan_name) &&
                <UIAccordion
                    customStyle={`${accordionStyles.no_decoration} ${accordionStyles.homecare_accordian}`}
                    customAccordionSummaryStyle={styles.custom_accordion_summary}
                    expanded={selectedAccordion == SELECT_DEVICE}
                    onChange={() => { selectedAccordion != SELECT_DEVICE ? handleAccordion(SELECT_DEVICE) : handleAccordion(ADD_DEVICE)}}
                    title={SELECT_DEVICE}
                    simple={true}>
                    <ChildPlanList
                      props={props}
                      setPageLoading={props.setPageLoading}
                      setDisableBtn={setDisableBtn}
                      setCoversNo={setCoversNo}
                    />
                </UIAccordion>
            }
            {/* For Comprehensive, directly disply child plans*/}
            {HOMECARE_PREMIUM_PRODUCTS.includes(parentPlanDetails.plan_name)&&
              <ChildPlanList
                props={props}
                setPageLoading={props.setPageLoading}
                setDisableBtn={setDisableBtn}
                setCoversNo={setCoversNo}
              />
            }
            {HOMECARE_PLANS.includes(parentPlanDetails.plan_name) && getMaxClaimValidity() &&
                <UIAccordion
                    customStyle={`${accordionStyles.no_decoration} ${accordionStyles.homecare_accordian}`}
                    customAccordionSummaryStyle={styles.custom_accordion_summary}
                    expanded={selectedAccordion == ADD_DEVICE}
                    onChange={() => { selectedAccordion != ADD_DEVICE ? handleAccordion(ADD_DEVICE) :handleAccordion(SELECT_DEVICE)}}
                    title={ADD_DEVICE}
                    simple={true}>
                    <div className={styles.hc_plan}>
                        <div className={styles.raise_sr_details}>
                            <AddDeviceDetails
                                props={props}
                                setDisableBtn={setDisableBtn}
                                setDeviceDetails={setDeviceDetails} />
                        </div>
                    </div>
                </UIAccordion>
            }

            <EraseSRListAlert is_open={earseSR} setEnableModal={setEarseSR} router={router}/>

            <div className={commonStyles.button_actions_sticky} data-varient='sticky' id="bottom-sticky-header">
                {/* PREVIOUS BUTTON */}
                {previousStepList.length>0 &&
                    <Button
                        disabled={props.selfserveReducer.landed_on_page === 'covers'}
                        className={commonStyles.cart_btn}
                        text={'Previous'}
                        variant='secondary'
                        onClick={() => {
                            if(router?.query?.app_render){
                                addAppRenderParams(router)
                            }else{
                                router.push('/account/plans')
                            }
                        }}
                    />
                }
                <Button
                    disabled={disableBtn}
                    className={commonStyles.cart_btn}
                    text={!isEditing ? 'Next' : 'Done'}
                    variant='primary'
                    onClick={() => { handlebutton() }}
                />

            </div>


        </div>
    )
}


const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect(mapStateToProps)(ChildPlanPage);
